/*eslint-disable */
import React, { useContext, useMemo, useState, useCallback } from 'react';

const PANEL_CONTEXT = React.createContext(null);

const usePanelContext = () => useContext(PANEL_CONTEXT);

/** @type {PanelContextProps} */
const INITIAL_STATE = {
    contentElement: null,
    onClose: null,
};

const PanelProvider = ({ children }) => {
    const [panelProps, setPanelProps] = useState(INITIAL_STATE);
    const [closingAnimatedPanel, setClosingAnimatedPanel] = useState(false);
    const [isFullScreen, setIsFullScreen] = useState(false);

    const openPanel = useCallback(({ title, contentElement, onClose, panelWidth, panelFullScreen }) => {
        setPanelProps({ title, contentElement, onClose, panelWidth });
        setIsFullScreen(!!panelFullScreen);
    }, []);

    const closePanel = useCallback(() => {
        if (panelProps.onClose) panelProps.onClose();
        setPanelProps(INITIAL_STATE);
    }, [panelProps.onClose]);

    const isPanelOpened = useMemo(() => panelProps.contentElement !== null);

    const value = useMemo(
        () => ({
            panelOpened: panelProps.contentElement != null,
            openPanel,
            closePanel,
            panelProps,
            closingAnimatedPanel,
            setClosingAnimatedPanel,
            isFullScreen,
            setIsFullScreen,
            isPanelOpened,
        }),
        [
            isPanelOpened,
            panelProps,
            openPanel,
            closePanel,
            closingAnimatedPanel,
            setClosingAnimatedPanel,
            isFullScreen,
            setIsFullScreen,
        ],
    );
    return <PANEL_CONTEXT.Provider value={value}>{children}</PANEL_CONTEXT.Provider>;
};

export { usePanelContext, PanelProvider };
